import React, { useRef, useEffect } from "react";

import "style/ComponentStyles.css";

import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";
import { useState } from "react";
const detail_Medmall =
  "https://redandblue.notion.site/MEDMall-1cb2e6d1d57c495fb07808dd000eed61";
const notice_site =
  "https://redandblue.notion.site/abd6e93ea54a4323b933f2f7b4af586f";
const RightMenu = ({ show, setShowMenu }: any) => {
  let history = useNavigate();
  const sampleLocation = useLocation();

  const useOutsideAlerter = (ref: any) => {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowMenu(false);
        }
      };
      document.addEventListener("keydown", handleClickOutside);
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const getHospitalName = async () => {
    if (sampleLocation.pathname === "/login") {
      return;
    }
  };

  useEffect(() => {
    getHospitalName();
  }, []);

  return (
    <div ref={wrapperRef}>
      <div className={"left-menu " + (show ? "on" : "off")}>
        <div onClick={() => setShowMenu(false)} className="btn-top-menu-close">
          <img className="" src="/svg/close.svg" alt="close" />
        </div>
        <div style={{ clear: "both" }}></div>
        {/* 메뉴바 */}
        <ul id="font-SCD7">
          <li onClick={() => window.open(detail_Medmall)}>
            <span>소개</span>
          </li>
          <li onClick={() => window.open(notice_site)}>
            <span>알림</span>
          </li>
          <li>
            <span>문의</span>
          </li>
          <li onClick={() => history("/mypage")}>
            <span>마이페이지</span>
          </li>
          <li onClick={() => history("/login")}>
            <span>로그아웃</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default React.memo(RightMenu);
